angular.module("leanlaw").controller("RegisterModalController", ["$scope", "$window", "alerts", "userService", "leanLawApi", "leanLawAuth", function ($scope, $window, alerts, userService, leanLawApi, leanLawAuth) {
  $scope.company = {
    name: null,
    size: null,
    phone: null
  };

  // TODO add the right size options
  $scope.sizeOptions = [{
    size: '1-4',
    label: '1-4 people'
  }, {
    size: '5-10',
    label: '5-10 people'
  }, {
    size: '11-20',
    label: '11-20 people'
  }, {
    size: '20+',
    label: '20+ people'
  }];
  userService.me().then(me => {
    $scope.me = me;
  });
  $scope.confirm = function () {
    $scope.saving = true;
    leanLawApi.registerCompany({
      body: $scope.company
    }).then(() => {
      $window.location.reload();
    }).catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.saving = false;
    });
  };
  $scope.logoff = function () {
    leanLawAuth.logoff();
  };
}]);